import { render, staticRenderFns } from "./SocialInformation.vue?vue&type=template&id=234ff128&scoped=true"
import script from "./SocialInformation.vue?vue&type=script&lang=js"
export * from "./SocialInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ff128",
  null
  
)

export default component.exports